const normalizeConversationMessageIdentityPart = (value) => {
  if (value === null || value === undefined) return null;
  const normalizedValue = String(value).trim();
  return normalizedValue || null;
};

const resolveConversationMessageClientRequestId = (message = null) =>
  normalizeConversationMessageIdentityPart(
    message?.additional_attributes?.client_request_id
  ) || normalizeConversationMessageIdentityPart(message?.client_request_id);

const buildConversationMessageIdentityAliases = (message = null) => {
  const aliases = new Set();
  const messageId = normalizeConversationMessageIdentityPart(message?.id);
  const echoId = normalizeConversationMessageIdentityPart(message?.echo_id);
  const clientRequestId = resolveConversationMessageClientRequestId(message);

  if (messageId) aliases.add(`message-${messageId}`);
  if (echoId) aliases.add(`message-${echoId}`);
  if (clientRequestId) aliases.add(`client-request-${clientRequestId}`);

  return aliases;
};

const findConversationMessageIdentityMatchIndex = (
  messages = [],
  candidateMessage = null
) => {
  const candidateAliases =
    buildConversationMessageIdentityAliases(candidateMessage);
  if (candidateAliases.size === 0) return -1;

  return (Array.isArray(messages) ? messages : []).findIndex((message) => {
    const messageAliases = buildConversationMessageIdentityAliases(message);
    return [...messageAliases].some((alias) => candidateAliases.has(alias));
  });
};

const resolveConversationMessageRenderKey = (message = null, index = 0) => {
  const clientRequestId = resolveConversationMessageClientRequestId(message);
  if (clientRequestId) return `client-request-${clientRequestId}`;

  const echoId = normalizeConversationMessageIdentityPart(message?.echo_id);
  if (echoId) return `echo-${echoId}`;

  const messageId = normalizeConversationMessageIdentityPart(message?.id);
  if (messageId) return `id-${messageId}`;

  return `index-${index}`;
};

export {
  buildConversationMessageIdentityAliases,
  findConversationMessageIdentityMatchIndex,
  normalizeConversationMessageIdentityPart,
  resolveConversationMessageClientRequestId,
  resolveConversationMessageRenderKey,
};
